import {
    createEntityAdapter,
    createSlice,
    createReducer,
    configureStore,
  } from '@reduxjs/toolkit'

const adapter = createEntityAdapter()

const effortsSlice = createSlice({
  name: 'efforts',
  initialState: [],
  reducers: {
    set: (s, a) => a.payload,
    setCompletersCount: (s, a) => {
      const { effortId, count } = a.payload;
      s.forEach(effort => {
        if (effort.id === effortId) {
          return _.set({...effort}, 'primaryGoal.completersCount', count);
        }
      });
    }
  },
});

const store = configureStore({
  reducer: {
    efforts: effortsSlice.reducer,
  },
  devTools: {
    name: 'Efforts',
  },
})

export default store
